import { render, staticRenderFns } from "./ad_1.vue?vue&type=template&id=05b49862&scoped=true"
import script from "./ad_1.vue?vue&type=script&lang=js"
export * from "./ad_1.vue?vue&type=script&lang=js"
import style0 from "./ad_1.vue?vue&type=style&index=0&id=05b49862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b49862",
  null
  
)

export default component.exports